import {combineReducers, createReducer} from '@reduxjs/toolkit';
import {
  hideModal,
  setMode,
  setSaveErrors,
  showLeftDrawer,
  showModal,
  showRightDrawer,
} from '@src/actions/ui.ts';
import {UI_MODES} from '@src/constants';

const initialDrawerState = {
  left: '',
  right: '',
};

export const drawers = createReducer(initialDrawerState, builder => {
  builder.addCase(showLeftDrawer, (state, {payload}) => {
    state.left = payload;
  });

  builder.addCase(showRightDrawer, (state, {payload}) => {
    state.right = payload;
  });
});

export const modal = createReducer(null, builder => {
  builder.addCase(showModal, (state, {payload}) => payload);
  builder.addCase(hideModal, () => null);
});

const initialMode = UI_MODES.BROWSE;

const mode = createReducer(initialMode, builder => {
  builder.addCase(setMode, (state, {payload}) => payload);

  builder.addCase(showLeftDrawer, state => {
    return state;
  });
});

const saveState = createReducer(
  {
    errors: [],
  },
  builder => {
    builder.addCase(setSaveErrors, (state, {payload}) => {
      state.errors = payload;
    });
  },
);

export default combineReducers({
  mode,
  modal,
  drawers,
  saveState,
});
